import React, { Fragment } from 'react';

import Cards from 'components/Cards';
import SmallCards from 'components/Cards/components/SmallCards';

import MediaLgDown from 'components/Responsive/MediaLgDown';
import MediaMdUp from 'components/Responsive/MediaMdUp';
import MediaSmDown from 'components/Responsive/MediaSmDown';

import InnerTabs from 'components/StoryletsAvailable/components/InnerTabs';
import StoryletStagger from 'components/StoryletsAvailable/components/StoryletStagger';
import WelcomeAndTravel from 'components/StoryletsAvailable/components/WelcomeAndTravel';
import { SOMETIMES, StoryletActiveTab as ActiveTab } from "types/subtabs";

export interface Props {
  onTabSwitch: (_?: any) => void,
  showOps: boolean,
  subtab: ActiveTab,
}

export default function Storylets({
  showOps,
  subtab,
  onTabSwitch,
}: Props) {
  return (
    <Fragment>
      <MediaLgDown>
        <MediaMdUp>
          <WelcomeAndTravel />
        </MediaMdUp>
      </MediaLgDown>

      <MediaSmDown>
        {showOps && <InnerTabs activeTab={subtab} onChange={onTabSwitch} />}
        {subtab === SOMETIMES ? <SmallCards /> : <StoryletStagger />}
      </MediaSmDown>

      <MediaMdUp>
        <Cards />
        <StoryletStagger />
      </MediaMdUp>

    </Fragment>
  );
}
